import { Flex } from "@chakra-ui/react";
import ButtonComp from "components/Button";
import DropDown from "components/DropDown";
import { Header } from "components/Header";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useState } from "react";

function CustomPricingRulesView() {
  const [isLoading] = useState(false);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header label={"Custom Pricing Rules"} isLoading={isLoading} />

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Mileage"} />
        {/* <Field.Root orientation="horizontal" w={"22rem"}> */}
        {/* <Field.Label textStyle={"md"}>Mileage</Field.Label> */}
        {/* </Field.Root> */}
        {/* <Input textStyle={"md"} /> */}
        <DropDown />
        <DropDown />
        {/* <Input textStyle={"md"} /> */}
      </Flex>
      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Car Age"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Engine Size"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Single Repair Limit"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Increase Price"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Luxury"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Air Bag Systems"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Emissions Failure"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"4x4"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Specialist"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Air Conditioning"} />
        <DropDown />
        <DropDown />
      </Flex>

      <Flex
        mt={"1rem"}
        alignItems={"center"}
        justifyContent={"flex-start"}
        gap={"1rem"}
      >
        <ToggleSwitch w={"12rem"} label={"Radio / CD / SAT Nav"} />
        <DropDown />
        <DropDown />
      </Flex>

      <ButtonComp alignSelf={"end"} mt={"2rem"} label="Save" keyname="save" />
    </Flex>
  );
}

export default CustomPricingRulesView;
